import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Grid } from '@mui/material';
import { useFeatureFlag } from 'modules/common/hooks';
import { useAutoAcceptSettings } from 'modules/Settings/hooks/useAutoAcceptSettings';
import { SourceByTimeChart } from '../components/SourceByTimeChart';
import { ClassificationBarChart } from '../components/NotesClassification/ClassificationBarChart';
import ClientChart from '../components/TimeSheetLabelCharts/ClientChart';
import ProjectChart from '../components/TimeSheetLabelCharts/ProjectChart';
import TaskChart from '../components/TimeSheetLabelCharts/TaskChart';
import { OEFCharContainer } from '../components/TimeSheetLabelCharts/OEFCharts';
import OEFChartContextProvider from '../components/TimeSheetLabelCharts/OEFCharts/OEFChartContextProvider';
import { MyUtilizationChart } from '../components/MyUtilizationChart';
import { KeywordCloudChart } from '../components/BubbleChart/KeywordCloudChart';
import { AutoAccept } from '../components/AutoAcceptChart/AutoAccept';
import { useLabelVisibility } from './hooks/useLabelVisibility';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between'
  },
  itemContainer: {
    width: '43%'
  },
  itemClassification: {
    alignSelf: 'flex-end',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%'
  },

  rightDiv: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  labelChartDiv: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    justifyContent: 'space-between'
  },
  labelChartGrid: {
    marginTop: theme.spacing(3)
  }
}));
const NotesInsightsFC: React.FC = () => {
  const classes = useStyles();
  const labelVisibility = useLabelVisibility();
  const { data } = useAutoAcceptSettings();
  const isTiAutoAcceptUserSettingsEnabled = useFeatureFlag(
    'isTiAutoAcceptUserSettingsEnabled'
  );
  return (
    <React.Fragment>
      <div className={classes.container}>
        <div className={classes.rightDiv}>
          <div className={classes.itemClassification}>
            <ClassificationBarChart />
            {data?.getAutoAcceptSettings?.enabled &&
              isTiAutoAcceptUserSettingsEnabled && <AutoAccept />}
          </div>
          <div>
            <MyUtilizationChart />
          </div>
          <Grid container className={classes.labelChartGrid}>
            {labelVisibility.CLIENT && (
              <Grid item xs={4}>
                <ClientChart />
              </Grid>
            )}
            {labelVisibility.PROJECT && (
              <Grid item xs={4}>
                <ProjectChart />
              </Grid>
            )}
            {labelVisibility.TASK && (
              <Grid item xs={4}>
                <TaskChart />
              </Grid>
            )}
          </Grid>
          {labelVisibility.SELECT && (
            <Grid container>
              <OEFChartContextProvider>
                <OEFCharContainer />
              </OEFChartContextProvider>
            </Grid>
          )}
        </div>

        <div className={classes.itemContainer}>
          <SourceByTimeChart />
          <KeywordCloudChart />
        </div>
      </div>
    </React.Fragment>
  );
};

export default memo(NotesInsightsFC);
